import {Injectable} from '@angular/core';
import {LocalStorageService,SessionStorageService} from 'ngx-webstorage';
import {ClaimDTO} from 'src/app/client/claims/claim.model';
import {IPortMySuffix} from 'src/app/shared/model/port-my-suffix.model';


@Injectable({ providedIn: 'root' })
export class StateStorageService {
    constructor(private $sessionStorage: SessionStorageService,
               private localStorage  :  LocalStorageService
        ) {}

    getPreviousState() {
        return this.$sessionStorage.retrieve('previousState');
    }

    resetPreviousState() {
        this.$sessionStorage.clear('previousState');
    }

    storePreviousState(previousStateName, previousStateParams) {
        const previousState = { name: previousStateName, params: previousStateParams };
        this.$sessionStorage.store('previousState', previousState);
    }

    getDestinationState() {
        return this.$sessionStorage.retrieve('destinationState');
    }

    storeUrl(url: string) {
        this.$sessionStorage.store('previousUrl', url);
    }

    getUrl() {
        return this.$sessionStorage.retrieve('previousUrl');
    }

    storeDestinationState(destinationState, destinationStateParams, fromState) {
        const destinationInfo = {
            destination: {
                name: destinationState.name,
                data: destinationState.data
            },
            params: destinationStateParams,
            from: {
                name: fromState.name
            }
        };
        this.$sessionStorage.store('destinationState', destinationInfo);
    }

    setCertificateData(key, value) {
        this.$sessionStorage.store(key, value);
    }

    getCertificateData(key) {
        return this.$sessionStorage.retrieve(key);
    }

    resetCertificateData(key) {
        this.$sessionStorage.clear(key);
    }

    setCertificateRequestScopeDTO(key, value) {
        this.$sessionStorage.store(key, value);
    }

    getsetCertificateRequestScopeDTO(key) {
        return this.$sessionStorage.retrieve(key);
    }

    resetsetCertificateRequestScopeDTO(key) {
        this.$sessionStorage.clear(key);
    }

    storePorts(ports: IPortMySuffix[]) {
        this.$sessionStorage.store('ports', ports);
    }

    getPorts() {
        let port=this.$sessionStorage.retrieve('ports');
        return port!=null? port:[];
    }

    storeTypeOfClient(type: string) {
        this.$sessionStorage.store('typeOfClient', type);
    }

    getTypeOfClient() {
        return this.$sessionStorage.retrieve('typeOfClient');
    }

    resetTypeOfClient() {
        return this.$sessionStorage.clear('typeOfClient');
    }

    storeCertificateDTO(type: any) {
        this.$sessionStorage.store('certificateDTO', type);
    }

    getCertificateDTO() {
        return this.$sessionStorage.retrieve('certificateDTO');
    }
    resetCertificateDTO() {
        return this.$sessionStorage.clear('certificateDTO');
    }

    storeSpotClientCertificateDTO(type: any) {
        this.$sessionStorage.store('spotCertificateDTO', type);
    }
    
    getSpotCertificateDTO() {
        return this.$sessionStorage.retrieve('spotCertificateDTO');
    }

    resetSpotCertificateDTO() {
        return this.$sessionStorage.clear('spotCertificateDTO');
    }

    storeSpotClientCertificateDTOForMail(type: any) {
        this.$sessionStorage.store('spotCertificateDTOForMail', type);
    }
    
    getStoreSpotClientCertificateDTOForMail() {
        return this.$sessionStorage.retrieve('spotCertificateDTOForMail');
    }

    resetStoreSpotClientCertificateDTOForMail() {
        return this.$sessionStorage.clear('spotCertificateDTOForMail');
    }

    storeBulkCertificateDTO(type: any) {
        this.$sessionStorage.store('certificateDTO', type);
    }

    getBulkCertificateDTO() {
        return this.$sessionStorage.retrieve('certificateDTO');
    }

    resetBulkCertificateDTO() {
        return this.$sessionStorage.clear('certificateDTO');
    }

    storeClientDTO(type: any) {
        this.$sessionStorage.store('clientDTO', type);
    }

    getClientDTO() {
        return this.$sessionStorage.retrieve('clientDTO');
    }

    resetClientDTO() {
        return this.$sessionStorage.clear('clientDTO');
    }
    
    storeLanguageKey(type: string) {
        this.$sessionStorage.store('languageKey', type);
    }

    getLanguageKey() {
        return this.$sessionStorage.retrieve('languageKey');
    }

    resetLanguageKey() {
        return this.$sessionStorage.clear('languageKey');
    }

    resetData(key) {
        this.$sessionStorage.clear(key);
    }
    setData(key, value) {
        this.$sessionStorage.store(key, value);
    }
    getData(key) {
        return this.$sessionStorage.retrieve(key);
    }
    storeClaimDTO(type: ClaimDTO) {
        this.$sessionStorage.store('claimDTO', type);
    }

    getClaimDTO() {
        return this.$sessionStorage.retrieve('claimDTO');
    }

    resetClaimDTO() {
        return this.$sessionStorage.clear('claimDTO');
    }


    setLocalStorageDataWithExpiry(key, value, ttlInMinute) {
        const now = new Date()
       // now.setHours(now.getHours() + ttl );   
        now.setMinutes(now.getMinutes() + ttlInMinute);     
        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
          const item = {
              value: value,
              expiry: now.getTime() 
          }
       //   localStorage.setItem(key, JSON.stringify(item))

       this.$sessionStorage.store(key , item)
      }

      getLocalStorageDataWithExpiry(key) {
        //const itemStr = localStorage.getItem(key)
        
        // if the item doesn't exist, return null
        

     //   const item = JSON.parse(itemStr)
        const item = this.$sessionStorage.retrieve(key);
        if (!item) {
            return null
        }
        const now = new Date()

        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(key)
            return null
        }
        return item.value
    }

    storeCountries(type: any) {
        this.localStorage.store('countries', type);
    }
    
    getCountries() {
        return this.localStorage.retrieve('countries');
    }
    
    storeStates(type: any) {
        this.localStorage.store('states', type);
    }

    getStates() {
        return this.localStorage.retrieve('states');
    }
   
    resetCountries() {
        return this.localStorage.clear('countries');
    }
    
    resetStates() {
        return this.localStorage.clear('states');
    }
    

    setCurrentSummaryPageUrl(reqId: number,data: any) {
        let ran=this.getRandomString(reqId);
        this.$sessionStorage.store(ran,data);
        return ran;
    }

    getCurrentSummaryPageUrl(reqId:string) {
        return this.$sessionStorage.retrieve(reqId);
    }

    contains(keyName) {
        return this.$sessionStorage.retrieve(keyName)!=null
    }


    private getRandomString(id:any): string {
        let outString: string = '';
        let inOptions: string = 'abcdefghijklmnopqrstuvwxyz0123456789';
    
        for(let i=1;i<=12;i++) {
            if(i%4==0) {
                outString+="-";
            }
            outString += inOptions.charAt(Math.floor(Math.random() * inOptions.length));
        }

        outString+="-"+id;
        return outString;
      }

    storeCountriesWithContinent(type: any) {
        this.localStorage.store('continent-countries', type);
    }
    
    getCountriesWithContinent() {
        return this.localStorage.retrieve('continent-countries');
    }
    
   
    resetCountriesWithContinent() {
        return this.localStorage.clear('continent-countries');
    }

}
